import { createSearchParams, useNavigate } from "react-router-dom";

// Components
import Button from "components/atoms/Button";

// Constants
import { GET_PARAMS } from "constants/popupConfig";

// Helpers
import { getImageSet } from "helpers/tournament";

// Hooks
import { useBreakpoint } from "hooks/useBreakpoint";
import { useCheckBalance } from "hooks/useCheckBalance";
import { makeLangUrl } from "helpers/makeLangUrl";
// Types
import { ImageRecord, TournamentDataType } from "types/Tournament";
import { GameType } from "types/Games";

// Url
import url from "url/index";

import "./styles.sass";

interface ITournamentBlock {
  name: string;
  description: string;
  image: ImageRecord[];
  lang: string;
  games: GameType[] | null;
  tournament: TournamentDataType;
}

const TournamentBlock: React.FC<ITournamentBlock> = ({
  games,
  name,
  description,
  image,
  tournament,
}) => {
  const { isTabletAndLess, isDesktop } = useBreakpoint();

  const navigate = useNavigate();
  const checkBalance = useCheckBalance();

  const gameToPlay = games ? games[0] : "";

  async function handleInitReal() {
    const isBalancePositive = checkBalance();
    if (isBalancePositive && gameToPlay && tournament) {
      const dataTournament = `${tournament.id}:${tournament.name}`
        .replaceAll(" ", "")
        .trim();
      navigate({
        pathname: makeLangUrl(
          url.routes.casino.game({ game: gameToPlay.urlAlias }),
        ),
        search: `?${createSearchParams({
          [GET_PARAMS.TOURNAMENT]: dataTournament,
        })}`,
      });
    } else {
      /* empty */
    }
  }

  const tournamentImage = getImageSet(image, isTabletAndLess);

  return (
    <div className="TournamentBlock">
      <div className="TournamentBlock__content">
        <div className="TournamentBlock__text-section">
          <span className="TournamentBlock_name">{name}</span>
          <span className="TournamentBlock_description">{description}</span>
          {isDesktop && (
            <div className="TournamentBlock_button">
              <Button
                variation="primary"
                label="profile.game.button"
                onClick={() => handleInitReal()}
              />
            </div>
          )}
        </div>
        <div className="TournamentBlock__image-section">
          <img src={tournamentImage} alt="tournamentImage" />
        </div>
        {!isDesktop && (
          <div className="TournamentBlock_button">
            <Button
              variation="primary"
              label="profile.game.button"
              onClick={() => handleInitReal()}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default TournamentBlock;
